import { BiSmile, BiSad } from 'react-icons/bi'
import { GoQuestion } from 'react-icons/go'
import { ImSpinner3 } from 'react-icons/im'

export function IconQuestion(props: any) {
  const size = props.size
  return <GoQuestion size={size} className="text-slate-600" />
}

export function IconSmile(props: any) {
  const size = props.size
  return <BiSmile size={size} className="text-pink-600" />
}

export function IconSad(props: any) {
  const size = props.size
  return <BiSad size={size} className="text-indigo-600" />
}

export function IconLoading(props: any) {
  const size = props.size
  return (
    <div className="App">
      <ImSpinner3
        // icon="spinner"
        size={size}
        className="text-emerald-600"
        style={{ animation: 'spin infinite 1s linear' }}
      />
    </div>
  )
}

export function getIconBySentiment(sentiment: string, size: number) {
  if (sentiment === 'loading') {
    return <IconLoading size={size} />
  }

  if (sentiment === 'positive') {
    return <IconSmile size={size} />
  } else if (sentiment === 'negative') {
    return <IconSad size={size} />
  } else if (sentiment === 'unknown') {
    return <IconQuestion size={size} />
  }
}
